export default ({
  onChange,
  forwardRef,
  value,
  accept = '',
  id = 'file_input',
}) => (
  <input
    type="file"
    data-testid="csvInput"
    id={id}
    accept={accept}
    ref={forwardRef}
    onChange={onChange}
    style={{ display: 'none' }}
    value={value}
  />
)
